<template>
	<div class="verify-container">
		<!-- 标题 -->
		<template v-if="loginMode === 1">
			<div class="title" style="margin-bottom: 1.226666rem">健康科普研究中心</div>
		</template>
		<template v-if="loginMode === 2">
			<div class="title">健康科普研究中心</div>
			<div class="subtitle">若该手机号未注册，我们将自动为您注册</div>
		</template>

		<!-- 密码表单 -->
		<div v-show="loginMode === 1">
			<el-form ref="ruleForm1" :model="formData" :rules="rules">
				<el-form-item prop="phone_number">
					<el-input
						autocomplete="new-password"
						type="number"
						oninput="if(value.length>11)value=value.slice(0,11)"
						maxlength="11"
						v-model="formData.phone_number"
						placeholder="请输入手机号"
					></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input autocomplete="new-password" :type="passType" v-model="formData.password" placeholder="请输入密码"></el-input>
					<img src="@/assets/close.png" class="eyes-img eyes-close" @click="passType = 'text'" v-show="passType === 'password'" />
					<img src="@/assets/open.png" class="eyes-img eyes-open" @click="passType = 'password'" v-show="passType === 'text'" />
				</el-form-item>

				<div class="row login-btn link" @click="submit">登录</div>
				<div class="row mode-change" @click="loginMode = loginMode === 1 ? 2 : 1">{{ loginMode === 2 ? '密码登录' : '验证码登录' }}</div>
			</el-form>
		</div>
		<!-- 短信登录表单 -->
		<div v-show="loginMode === 2">
			<el-form ref="ruleForm2" :model="formData" :rules="rules">
				<el-form-item prop="phone_number">
					<el-input
						autocomplete="new-password"
						type="number"
						oninput="if(value.length>11)value=value.slice(0,11)"
						maxlength="11"
						v-model="formData.phone_number"
						placeholder="请输入手机号"
					></el-input>
				</el-form-item>
				<el-form-item prop="captcha">
					<el-input autocomplete="new-password" type="number" v-model="formData.captcha" placeholder="请输入验证码"></el-input>
					<div class="get-code link" v-if="captchaTime === 60" @click="smsSend">获取验证码</div>
					<div class="get-code get-code-dis" v-else>{{ captchaTime }}秒后重发</div>
				</el-form-item>
				<div class="row login-btn link" @click="submit">登录</div>
				<div class="row mode-change" @click="loginMode = loginMode === 1 ? 2 : 1">{{ loginMode === 2 ? '密码登录' : '验证码登录' }}</div>
			</el-form>
		</div>
		<!-- 用户协议和隐私协议 -->
		<div class="agreement none-select">
			<el-checkbox v-model="checked"></el-checkbox>
			<div class="text link" @click="checked = !checked">
				登录即视为同意
				<span>《用户协议》</span>
				和
				<span>《隐私协议》</span>
			</div>
		</div>
	</div>
</template>
<script>
let captchaTimeOut = '';
import validate from '@/utils/validate.js';
import { Toast } from 'vant';
export default {
	props: {
		mode: {
			type: String,
			default: 'exam'
		}
	},
	data() {
		return {
			passType: 'password',
			loginMode: 2, // 1=密码登录,2=验证码登录
			captchaTime: 60,
			captchaBusy: false,
			checked: true,
			formData: {
				phone_number: '',
				password: '',
				captcha: ''
			},
			rules: {}
		};
	},
	watch: {
		loginMode: {
			immediate: true,
			handler: function(value, oldValue) {
				this.metchFormInfo(value);
			}
		}
	},
	created() {
		this.mpLogin().then(() => {
			console.log('登录完成');
		});
	},
	methods: {
		// 匹配信息
		metchFormInfo(value) {
			let rules = {};
			if (value === 1) {
				rules = {
					phone_number: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validate.checkPhone, trigger: 'blur' }],
					password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: validate.checkPassword, trigger: 'blur' }]
				};
			} else {
				rules = {
					phone_number: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validate.checkPhone, trigger: 'blur' }],
					captcha: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
				};
			}
			this.rules = rules;
			this.formData = {
				phone_number: '',
				password: '',
				captcha: ''
			};
			this.$nextTick(() => {
				if (this.$refs['ruleForm1']) this.$refs['ruleForm1'].clearValidate();
				if (this.$refs['ruleForm2']) this.$refs['ruleForm2'].clearValidate();
			});
		},
		// 发送短信验证码
		smsSend() {
			if (this.captchaBusy) return;
			Toast.loading({
				message: '发送中...',
				forbidClick: true,
				duration: 0
			});
			this.captchaBusy = true;
			this.service2('client/stu/sendSms', {
				phone_number: this.formData.phone_number
			})
				.then(() => {
					captchaTimeOut = setInterval(() => {
						this.captchaTime--;
						if (this.captchaTime === 0) {
							clearInterval(captchaTimeOut);
							this.captchaTime = 60;
						}
					}, 1000);
				})
				.finally(() => {
					Toast.clear();
					setTimeout(() => {
						this.captchaBusy = false;
					}, 1000);
				});
		},
		submit() {
			if (!this.checked) {
				if (this.$store.getters.isPc) {
					this.$message({
						message: '请阅读并同意《用户协议》和《隐私政策》',
						type: 'warning'
					});
				} else {
					this.$toast('请阅读并同意《用户协议》和《隐私政策》');
				}
				return;
			}

			this.$refs[this.loginMode === 1 ? 'ruleForm1' : 'ruleForm2'].validate(valid => {
				if (valid) {
					this.service2('client/stu/login', {
						...this.formData,
						mode: this.loginMode,
						code: this.$store.getters.code
					})
						.then(res => {
							this.$store.dispatch('setToken', res.data.token);
							this.$store.dispatch('setRefreshToken', res.data.refresh_token);
							this.$store.dispatch('setStuInfo', this.formData.phone_number);
							this.service2('client/exam/order', {
								type: this.mode
							}).then(res => {
								this.$router.replace({
									name: this.mode,
									params: {
										name: 'choice'
									}
								});
							});
						})
						.catch(res => {});
				}
			});
		}
	}
};
</script>
<style scoped lang="less">
@import './Login.less';
</style>
